import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SearchIcon from '@material-ui/icons/Search';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import TipoPerfil from '../../../../constants/tipoPerfil';
import { getPaginaDeRegistros } from '../../../../services/usuario/UsuarioService';
import Pagination from '../../../shared/pagination/';
import QuemEQuemCardConselheiro from '../card/conselheiro';
import QuemEQuemCardEquipeTecnica from '../card/equipeTecnica';
import QuemEQuemCardInterlocutor from '../card/interlocutor';
import useStyles from './styles';
import {getEntidades} from "../../../../services/usuario/EntidadeService";

const QuemEQuemList = () => {
  const classes = useStyles();

  const [filtro, setFiltro] = useState({ nome: '', entidade: '' });
  const [tipoPerfil, setTipoPerfil] = useState('');
  const [mostrarBotaoFiltrar, setMostrarBotaoFiltrar] = useState(true);

  const limparFiltros = () => {
    setFiltro({ nome: '', entidade: '' })
    setTipoPerfil('');
    setMostrarBotaoFiltrar(true)
  };

  useEffect(() => {
    if (mostrarBotaoFiltrar) {
      getConselheiros(0);
      getEquipeTecnica(0);
      getInterlocutores(0);
    }
  }, [mostrarBotaoFiltrar])

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFiltro({ ...filtro, [name]: value })
  };

  const [conselheiros, setConselheiros] = useState([]);
  const [equipeTecnica, setEquipeTecnica] = useState([]);
  const [interlocutores, setInterlocutores] = useState([]);
  const [entidades, setEntidades] = useState([]);


  const [paginacaoConselheiro, setPaginacaoConselheiro] = useState({ pagina: 0, totalDePaginas: 0 });
  const [paginacaoEquipeTecnica, setPaginacaoEquipeTecnica] = useState({ pagina: 0, totalDePaginas: 0 });
  const [paginacaoInterlocutor, setPaginacaoInterlocutor] = useState({ pagina: 0, totalDePaginas: 0 });

  const getConselheiros = async (page) => {
    try {
      const response = await getPaginaDeRegistros(page, filtro, 'CONSELHEIRO');
      const { data } = response;
      const { content, totalPages } = data;
      setConselheiros(content);
      setPaginacaoConselheiro({ pagina: page, totalDePaginas: totalPages })
    } catch (e) {

    }
  };

  const getEquipeTecnica = async (page) => {
    try {
      const response = await getPaginaDeRegistros(page, filtro, 'EQUIPE_TECNICA');
      const { data } = response;
      const { content, totalPages } = data;
      setEquipeTecnica(content);
      setPaginacaoEquipeTecnica({ pagina: page, totalDePaginas: totalPages })
    } catch (e) {

    }
  };

  const getInterlocutores = async (page) => {
    try {
      const response = await getPaginaDeRegistros(page, filtro, 'INTERLOCUTOR');
      const { data } = response;
      const { content, totalPages } = data;
      setInterlocutores(content);
      setPaginacaoInterlocutor({ pagina: page, totalDePaginas: totalPages })
    } catch (e) {

    }
  };

  const conselheirosSection = () => {
    return (
      <>
        {conselheiros.length > 0 && (
          <div>
            <p className={classes.titulo}>
              {'Conselheiros'}
              <span className={classes.small}>Exibição por ordem alfabética</span>
              {' '}

            </p>
            <div className={classes.grid}>
              {conselheiros.map((conselheiro) => (
                <QuemEQuemCardConselheiro conselheiro={conselheiro} key={conselheiro.id} />
              ))}
            </div>
            {paginacaoConselheiro.totalDePaginas > 1 && <Pagination
              pagina={paginacaoConselheiro.pagina}
              tamanhoDaPagina={8}
              totalDePaginas={paginacaoConselheiro.totalDePaginas}
              onChangePage={getConselheiros}
            />}
            
          </div>
        )}
      </>
    )
  }

  const equipeTecnicaSection = () => {
    return (
      <>
        {equipeTecnica.length > 0 && (
          <div>
            <p className={classes.titulo}>
              {'Equipe Técnica'}
              <span className={classes.small}>Exibição por ordem alfabética</span>
              {' '}

            </p>
            <div className={classes.grid}>
              {equipeTecnica.map((et) => (
                <QuemEQuemCardEquipeTecnica equipeTecnica={et} key={et.id} />
              ))}
            </div>
            {paginacaoEquipeTecnica.totalDePaginas > 1 && <Pagination
              pagina={paginacaoEquipeTecnica.pagina}
              tamanhoDaPagina={8}
              totalDePaginas={paginacaoEquipeTecnica.totalDePaginas}
              onChangePage={getEquipeTecnica}
            />}
            
          </div>
        )}
      </>
    )
  }

  const interlocuoresSectino = () => {
    return (
      <>
        {interlocutores.length > 0 && (
          <div>
            <p className={classes.titulo}>
              {'Interlocutores'}
              <span className={classes.small}>Exibição por ordem alfabética</span>
              {' '}

            </p>
            <div className={classes.grid}>
              {interlocutores.map((interlocutor) => (
                <QuemEQuemCardInterlocutor interlocutor={interlocutor} key={interlocutor.id} />
              ))}
            </div>
            {paginacaoInterlocutor.totalDePaginas > 1 && <Pagination
              pagina={paginacaoInterlocutor.pagina}
              tamanhoDaPagina={8}
              totalDePaginas={paginacaoInterlocutor.totalDePaginas}
              onChangePage={getInterlocutores}
            />}
          </div>
        )}
      </>
    )
  }
  useEffect(() => {
    getConselheiros(paginacaoConselheiro.pagina);
    getEquipeTecnica(paginacaoEquipeTecnica.pagina);
    getInterlocutores(paginacaoInterlocutor.pagina);
    getEntidades().then((response) => setEntidades(response?.data));
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    switch (tipoPerfil) {
      case TipoPerfil.CONSELHEIRO:
        getConselheiros(0);
        setEquipeTecnica([]);
        setInterlocutores([]);
        break;
      case TipoPerfil.EQUIPE_TECNICA:
        getEquipeTecnica(0);
        setConselheiros([]);
        setInterlocutores([]);
        break;
      case TipoPerfil.INTERLOCUTOR:
        getInterlocutores(0);
        setConselheiros([]);
        setEquipeTecnica([]);
        break;
      default:
        getConselheiros(0);
        getEquipeTecnica(0);
        getInterlocutores(0);
        break;
    }

    setPaginacaoConselheiro(0);
    setPaginacaoEquipeTecnica(0);
    setPaginacaoInterlocutor(0);

    setMostrarBotaoFiltrar(false);
  };

  return (
    <>
      <div id="conteudo" style={{ width: '100%' }}>
        <form onSubmit={handleSubmit}>
          <div className={classes.barraFiltroDiv}>
            <div className={classes.barraFiltro}>
              <Grid container spacing={3}>
                <Grid item md={3} sm={12} xs={12}>
                  <TextField
                    id="nome"
                    name="nome"
                    fullWidth
                    variant='outlined'
                    value={filtro.nome}
                    onChange={handleChange}
                    placeholder="Digite sua busca"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon style={{ color: '#0B4FD9', cursor: 'pointer' }} />
                        </InputAdornment>
                      ),
                      endAdornment: (filtro.nome ?
                        <InputAdornment onClick={() => setFiltro({ ...filtro, nome: '' })} position="start">
                          <CloseIcon style={{ color: '#5e6784', cursor: 'pointer' }} />
                        </InputAdornment> : <></>
                      ),
                    }}
                  />
                </Grid>
                <Grid item md={2} sm={4} xs={6}>
                  <Select
                    id="perfil"
                    name="perfil"
                    value={tipoPerfil}
                    onChange={(event) => setTipoPerfil(event.target.value)}
                    fullWidth
                    displayEmpty
                    variant="outlined"
                    IconComponent={ExpandMoreIcon}
                  >
                    <MenuItem value="" disabled>
                      <span style={{ color: '#5e6784' }}>Tipo de Perfil</span>
                    </MenuItem>
                    <MenuItem value={TipoPerfil.CONSELHEIRO}>Conselheiro</MenuItem>
                    <MenuItem value={TipoPerfil.EQUIPE_TECNICA}>Equipe Técnica</MenuItem>
                    <MenuItem value={TipoPerfil.INTERLOCUTOR}>Interlocutor</MenuItem>
                  </Select>
                </Grid>
                <Grid item md={3} sm={4} xs={6}>
                  <Select
                    id="entidade"
                    name="entidade"
                    value={filtro.entidade}
                    onChange={handleChange}
                    variant="outlined"
                    displayEmpty
                    fullWidth
                    IconComponent={ExpandMoreIcon}
                  >
                    <MenuItem value="" disabled>
                      <span style={{ color: '#5e6784' }}>Entidade</span>
                    </MenuItem>
                    {entidades.map((entidade) => (
                      <MenuItem
                        key={entidade.id}
                        value={entidade.id}
                      >
                        {entidade.descricao} ({entidade.sigla})
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                {/* {mostrarBotaoFiltrar && */}
                <Grid item md={2}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                  >
                    Aplicar filtro
                  </Button>
                </Grid>

                {/* } */}
                {/* {!mostrarBotaoFiltrar && */}
                <Grid item md={2}>
                  <Button onClick={() => limparFiltros()}
                    variant="outlined"
                    fullWidth >
                    Limpar
                    filtros
                    </Button>
                </Grid>
                {/* } */}
              </Grid>
            </div>
          </div>

          {conselheirosSection()}
          {equipeTecnicaSection()}
          {interlocuoresSectino()}

        </form>
      </div>
    </>
  );
};

export default withRouter(QuemEQuemList);
